module.exports = __webpack_public_path__ + "static/media/puzzle-1-bg.cc014a96.svg";